import React from 'react';
import PropTypes from 'prop-types';

const className = ({buttonType, section, isPrimary, isLoading}) => {
  const submissionClass = `submission-form__${buttonType}`;
  const sectionClass = `section-${section}`;
  const primaryOrSecondaryClass = isPrimary? 'is-primary' : 'is-light';
  const loadingClass = isLoading? 'is-loading': '';

  return [
    submissionClass,
    sectionClass,
    'button',
    loadingClass,
    primaryOrSecondaryClass
  ].join(' ');
};

const FormNavigation = (props)=> {
  const {
    isDisabledSubmitButton,
    isLoading,
    section,
    showBackButton,
    showNextButton,
    showFinalSubmitButton,
    handleBack
  } = props;

  return (
    <span>
        <div className="submission-form__field-group-link">
          {
            showBackButton &&
            <button
              type="button"
              className={className({
                buttonType: 'back-button',
                section,
                isPrimary: true
              })}
              onClick={handleBack.bind(this)}
            >
              &lt; Back
            </button>
          }
          {
            showNextButton &&
            <button
              type="next"
              className={className({
                buttonType: 'button',
                section,
                isPrimary: !isLoading,
                isLoading: isLoading
              })}
            >
               Next &gt;
            </button>
          }
          {
            showFinalSubmitButton &&
            <button
              disabled={isDisabledSubmitButton}
              type="submit"
              className={className({
                buttonType: 'submit-button',
                section,
                isPrimary: !isDisabledSubmitButton
              })}
            >
              Submit
            </button>
          }
          </div>
      </span>
  );
};

FormNavigation.propTypes = {
  isDisabledSubmitButton: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  handleBack: PropTypes.func.isRequired,
  section: PropTypes.number.isRequired,
  showBackButton: PropTypes.bool.isRequired,
  showNextButton: PropTypes.bool.isRequired,
  showFinalSubmitButton: PropTypes.bool.isRequired,
};

export default FormNavigation;
